import { render, staticRenderFns } from "./BasicModal.vue?vue&type=template&id=5ea5b55b&"
import script from "./BasicModal.vue?vue&type=script&lang=ts&"
export * from "./BasicModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports